var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.days),function(day){return [_c('div',[_vm._v("\n            "+_vm._s(new Date(day.date))+"\n        ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }